import { AutocompleteInput, useGetList } from 'react-admin';
import { useState, useMemo } from 'react';

export const PdfCategoryAutoCompleteInput = (props: any) => {
    const [searchText, setSearchText] = useState('');
    const [selectedItem, setSelectedItem] = useState<any>(null);

    const { data, isLoading } = useGetList('pdf-categories', {
        pagination: { page: 1, perPage: 50 },
        filter: searchText ? { name: searchText, deleted: false } : { deleted: false },
    });

    const choices = useMemo(() => {
        const dataArray = data || [];
        if (selectedItem && !dataArray.find((item: any) => item.id === selectedItem.id)) {
            return [selectedItem, ...dataArray];
        }
        return dataArray;
    }, [data, selectedItem]);

    return (
        <AutocompleteInput
            {...props}
            source={props.source || 'categoryId'}
            fullWidth
            label="Pdf Category"
            choices={choices}
            optionText="name"
            optionValue="id"
            loading={isLoading}
            setFilter={value => setSearchText(value)}
            onChange={value => {
                const selected = choices.find((item: any) => item.id === value);
                if (selected) {
                    setSelectedItem(selected);
                }
                if (props.onChange) {
                    props.onChange(value);
                }
            }}
            debounce={500}
            shouldRenderSuggestions={(val: string) => {
                return val.trim().length >= 0;
            }}
        />
    );
};
